import React from "react";
import { DividerContainer, Line, DividerProps } from "./Divider-styles";

interface PropTypes extends DividerProps {}

function Divider(props: PropTypes) {
  let { size, line, weight } = props;
  return (
    <DividerContainer size={size}>
      {line && <Line line={line} weight={weight} />}
    </DividerContainer>
  );
}

Divider.defaultProps = {
  size: "m",
};

export default Divider;
